export const VIEW_MODE_NORMAL = 'VIEW_MODE_NORMAL';
export const VIEW_MODE_PREVIEW = 'VIEW_MODE_PREVIEW';